module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAuCAMAAADwdKLKAAAAOVBMVEUAAAAAAAAAAAAAAAAgHA12YSj5yUn4yUj1xkf0xkfyxEbvwUXuwEXvwUWReC1NRBoAAADFnjr8zEmwGVrTAAAAEnRSTlMBCwQJFibk3NPJvbGikDMeEmH20wzTAAAAZ0lEQVQoz+3TSw6AIAxFUV8Lfvjr/hcrNCEoxAWYcCcvPfMuH9HVR1l5UM6KQTF16u90PddRt6DC1uuuAej9rYcGEUEfTzURVN4J0TS1qqCwslWdYGUnyj4JVk6eZVmwMoNkG3Zn1w08vi5ZQik2TQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/nuevo.png
// module id = 525
// module chunks = 0